export const NBSP = '\u00A0';
export const LF = '\u000A';
export const MDASH = '\u2014';
